//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DpColumns',
  props: {
    bordered: { type: Boolean, default: false },
    columns: { type: Number, default: null },
  },
  computed: {
    numberOfColumns() {
      if (this.columns !== null) return this.columns;
      return this.$slots.default
        .filter((slot) => slot.componentOptions && slot.componentOptions.tag === 'dp-column')
        .length;
    },
  },
};
